class RyderMarquee {
	constructor(el, direct) {
		this.hero = $(el).parent().get(0)
		this.wrapper = el
		this.delta = 0
		this.transform = 0
		this.step = (device != 'mobile') ? 2 : 1
		this.direct = direct % 2
		this.hover = (device != 'mobile') ? true : false
		this.isHover = false

		if (this.direct == 1) {
			this.wrapper.style.transform = `translate3d(0, -${this.wrapper.getBoundingClientRect().height / 2}px, 0)`;
			this.transform = -this.wrapper.getBoundingClientRect().height / 2
		}

		if (this.hover) {
			$(el).hover(() => {
				this.isHover = true
			}, () => {
				this.isHover = false
			})
		}
	}

	animate() {
		if (!this.isHover) {
			this.transform += this.step
		}

		if (this.direct == 1) {
			if (this.transform > 0) {
				this.transform = -this.wrapper.getBoundingClientRect().height / 2;
			}
			this.wrapper.style.transform = `translate3d(0, ${this.transform}px, 0)`;
		} else {
			if (this.transform > this.wrapper.getBoundingClientRect().height / 2) {
				this.transform = 0;
			}
			this.wrapper.style.transform = `translate3d(0, -${this.transform}px, 0)`;
		}
	}

	render() {
		this.scrollY = $(window).scrollTop()

		const bounding = this.hero.getBoundingClientRect();
		const distance = (window.innerHeight + this.scrollY) - (bounding.top + this.scrollY);
		const percentage = distance / ((window.innerHeight + bounding.height) / 100);

		if (percentage > 0 && percentage < 100) {
			this.animate();
		}
	}

	create() {
		gsap.ticker.add(this.render.bind(this));
	}
}



function Wave({ }) {
	return {
		$template: '#wave-template',
		// mounted(el) {}
	}
}


function Arrow({ }) {
	return {
		$template: '#arrow-template',
		mounted(el) {
			ScrollTrigger.create({
				toggleActions: "play pause resume reverse", //重覆觸發
				trigger: el,
				start: "top 80%",
				// markers: true,
				onToggle: ({ progress, direction, isActive }) => {
					if (isActive) {

						let c = $(el).parents(".pointer-events-none").length

						if (c) {
							return
						}

						gsap.timeline({
							overwrite: true,
						}).set($(".arrow", el), {
							xPercent: 0,
						}).to($(".arrow", el), {
							duration: .2,
							xPercent: 100,
						}).set($(".arrow", el), {
							xPercent: -100,
						}).to($(".arrow", el), {
							duration: .2,
							xPercent: 0,
						})
					}
				}
			});
		}
	}
}



function glitchHandler(el) {
	let c = new SplitText(el, {
		type: "chars",
	})

	let $tl = gsap.timeline({
		paused: true
	}).to(c.chars, {
		duration: .16,
		opacity: 0.3,
		stagger: {
			each: .04,
			from: "start",
			onComplete: function() {
				if (Math.random() > 0.4) {
					gsap.to(this.targets(), {
						duration: .16,
						delay: 0.2,
						opacity: 1,
					})
				} else {
					gsap.to(this.targets(), {
						duration: .16,
						delay: 0.3,
						opacity: 1,
						repeat: 1,
					})
				}
			}
		},
	})

	$(el).on("mouseenter", function() {
		$tl.play(0)
	})
}



$("#preload").delay(500).fadeOut(500)



$(".scrolldown").on("click", function() {
	gsap.to(window, {
		duration: 1.2,
		scrollTo: $(window).height(),
		ease: 'power2.inOut',
	});
})



$(window).on("resize", function() {
	if ($(this).width() > 1200) {
		if (window.device == 'mobile') {
			location.reload()
		}
		window.device = 'desktop';
	} else {
		if (window.device == 'desktop') {
			location.reload()
		}
		window.device = 'mobile';
	}
}).trigger("resize")




let $hamburger_tl

function hamburgerHandler(el) {
	let _open = false

	$hamburger_tl = gsap.timeline({
		paused: true
	}).to($(el).children().eq(0), {
		duration: 0.2,
		y: 7,
		width: '100%',
	}).to($(el).children().eq(2), {
		duration: 0.2,
		y: -7,
		width: '100%',
	}, "<").to($(el).children().eq(1), {
		duration: 0.2,
		opacity: 0,
	}).to($(el).children().eq(0), {
		duration: 0.2,
		rotation: 35,
	}, "<").to($(el).children().eq(2), {
		duration: 0.2,
		rotation: -35,
	}, "<")

	$(el).on("click", function() {
		if (!_open) {
			_open = true
			$hamburger_tl.play()
			$("#mobile-topmenuWrap").addClass("is-open")
		} else {
			_open = false
			$hamburger_tl.reverse()
			$("#mobile-topmenuWrap").removeClass("is-open")
		}
	})
}





$(window).on("load", function() {
	ScrollTrigger.refresh();
})